import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sendmessageisopen: false,
  selectedmail :null,
  status: 'idle',
};


export const mailSlice = createSlice({
  name: 'mail',
  initialState,
  
  reducers: {
    SelectMail : (state,action)=> {
      state.selectedmail = action.payload;
    },
    OpenSendMessage: (state) => {
      
      state.sendmessageisopen = true;
    },
    CloseSendMessage: (state) => {
      state.sendmessageisopen = false;
    },
  },
});

export const {SelectMail, OpenSendMessage, CloseSendMessage} = mailSlice.actions;
export const selectselectedmail = (state) => state.mail.selectedmail;

export const selectsendmessageisopen = (state) => state.mail.sendmessageisopen;

export default mailSlice.reducer;
